import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ACTIONS from '../../store/action';
import { hexToRgb } from './GlobalFunctions';
import { Alert as UIAlert, AlertDescription } from '../ui/alert';
import { X } from 'lucide-react';

const Alert = ({ type, message, open, hideDuration = 2500, close, toggleAlertMessage, branding }) => {
  const handleClose = () => {
    if (close) {
      close(false, null);
    }
    toggleAlertMessage(false, null);
  };

  useEffect(() => {
    if (!open || !hideDuration) return;
    const timer = setTimeout(handleClose, hideDuration);
    return () => clearTimeout(timer);
  }, [open, hideDuration]);

  if (!open) return null;

  const primaryColor = branding?.colors?.primaryColor;
  const rgb = primaryColor ? hexToRgb(primaryColor) : null;
  const isSuccess = type === 'success';
  const bgStyle = isSuccess && rgb
    ? { background: `rgba(${rgb.r},${rgb.g},${rgb.b},0.9)` }
    : isSuccess
      ? { background: 'hsl(var(--primary))' }
      : { background: '#FFD700' };
  const textStyle = isSuccess ? { color: '#fff' } : { color: '#130834' };

  return (
    <div className="fixed top-4 right-4 z-[9999] w-full max-w-[300px]">
      <UIAlert
        className="border-0 shadow-lg"
        style={{ ...bgStyle, ...textStyle }}>
        <div className="flex items-start justify-between gap-2">
          <AlertDescription className="flex-1 m-0 text-inherit">{message}</AlertDescription>
          <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            className="shrink-0 rounded p-1 opacity-80 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-white">
            <X size={14} strokeWidth={1.5} />
          </button>
        </div>
      </UIAlert>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { message, hideDuration, status, severity } = state.alertMessage || {};
  return {
    branding: state.branding,
    message,
    hideDuration,
    open: status,
    type: severity,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleAlertMessage: (status, message) => dispatch(ACTIONS.toggleAlertMessage(status, message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
